import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import {
  GetInventarioDigitacaoResponse,
  GetInventarioResponse,
} from '../../responses/suprimentos/inventario.response';

/**
 * Leitura de inventário via Orquestrador de Suprimentos: junta os dados brutos de Suprimentos
 * (só id_produto) com os dados de exibição do cadastro de produto (API Produto), evitando
 * concorrência de chamadas no front. Espelha o InventarioConsultaOrquestradorController.
 */
@Injectable({ providedIn: 'root' })
export class InventarioConsultaOrquestradorService extends CommonService {
  private readonly apiUrl: string = environment.urlApiOrquestradorSuprimentos + 'InventarioConsultaOrquestrador';

  constructor(private httpClient: HttpClient) {
    super();
  }

  public getAll(
    idStatusInventario?: number | null,
    idTipoOrigemInventario?: number | null,
    descricao?: string,
    pagina: number = 1,
    tamanhoPagina: number = 20
  ): Observable<GetInventarioResponse> {
    let params = new HttpParams()
      .set('pagina', pagina.toString())
      .set('tamanhoPagina', tamanhoPagina.toString());

    if (idStatusInventario != null) params = params.set('idStatusInventario', idStatusInventario.toString());
    if (idTipoOrigemInventario != null) params = params.set('idTipoOrigemInventario', idTipoOrigemInventario.toString());
    if (descricao) params = params.set('descricao', descricao);

    return this.httpClient
      .get<GetInventarioResponse>(this.apiUrl, { params, ...this.addHeaderToken() })
      .pipe(catchError(this.handleError));
  }

  public getDigitacao(idInventario: number): Observable<GetInventarioDigitacaoResponse> {
    return this.httpClient
      .get<GetInventarioDigitacaoResponse>(
        `${this.apiUrl}/idInventario/${idInventario}/digitacao`,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }
}
